// extracted by mini-css-extract-plugin
export default {"fileDownloadTable":"DownloadReports__fileDownloadTable__cdc1634fab064275baf6"};